export default __webpack_public_path__ + "static/media/demo-post-3.c6ed407e.jpg";